import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import TYPES from "../../../ioc/types";
import { DefaultSelectable } from "../../menu/interfaces";
import { GeometryService } from "../../ui-services/geometry-ui-service";
import { TextContent } from "../text-content";
import { ItemDefinitionDTO } from "../../../shared/dtos";

const { lazyInject } = getDecorators(container);

export class ShopItem extends DefaultSelectable {
    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    private itemName: TextContent;
    // TODO: improve to be able to buy multiple items at the same time
    //    private quantityLabel: TextContent;
    private itemPrice: TextContent;

    constructor(x: number, y: number, item: ItemDefinitionDTO, scene: Phaser.Scene) {
        super(scene, x, y);
        this.buildIcon(x, y, item);
        this.itemName = new TextContent(x, y + 20, item.name, scene);
        this.itemPrice = new TextContent(x, y + 30, item.buy_price + "", scene);
        const graphics = this.scene.add.graphics();

        this.add(graphics);
        this.add(this.itemName);
        this.add(this.itemPrice);
        this.geometryService.initGraphicContext(graphics);
    }

    public buildIcon(x: number, y: number, item: ItemDefinitionDTO) {
        const spriteData = item.sprite_data;
        if (!spriteData) {
            return;
        }
        //        console.log('building icon for item: ', item)
        const itemSprite = this.scene.add.sprite(
            x + spriteData.width / 2,
            y + 5,
            "items/" + spriteData.image_path,
            parseInt(item.sprite_data.frame_name)
        );
        //        const itemSprite = this.physics.add.sprite(x, y, 'atlas_sheet', 'sprite1');
        itemSprite.setScale(1, 1);
        this.add(itemSprite);
    }
}
